import { useState } from 'react';
import { Card, Button, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import DeleteAccountModal from './DeleteAccountModal';

const { Title, Paragraph } = Typography;

/**
 * Danger-zone panel: lets a user permanently delete their own account via
 * the password-confirmed DeleteAccountModal.
 */
function DeleteAccount() {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <Card style={{ marginTop: 16 }}>
            <Title level={5} style={{ marginTop: 0 }}>Danger zone</Title>
            <Paragraph type="secondary" style={{ marginBottom: 12 }}>
                Permanently delete your account: your login, your person entity, and everything
                owned by it (connections, messages). This cannot be undone.
            </Paragraph>
            <Button danger icon={<DeleteOutlined />} onClick={() => setModalOpen(true)}>
                Delete account
            </Button>

            <DeleteAccountModal open={modalOpen} onClose={() => setModalOpen(false)} />
        </Card>
    );
}

export default DeleteAccount;
